import React, { useState } from 'react';
import { BottomCarSearch } from '@components/molecules/BottomCarSearch';
import { NumberPicker } from '@components/atoms/NumberPicker';
import { RoundProfilePicture } from '@components/atoms/RoundProfilePicture';
import { Button, ButtonMode } from '@components/atoms/Button';
import styles from './CarSearchWithPicker.module.css';
import { useTranslation } from 'react-i18next';

export const CarSearchWithPicker: React.FC = () => {
    const { t } = useTranslation();

    const translations = {
        select: t('car-search-with-picker.select'),
        apply: t('car-search-with-picker.apply'),
    };

    const [activeIcon, setActiveIcon] = useState<'disponivel' | 'proximo' | null>(null);

    //const [pickerValue, setPickerValue] = useState({ distance: '2 km' });
    const [pickerValue, setPickerValue] = useState({ distance: '' });
    const [tempPickerValue, setTempPickerValue] = useState(pickerValue);

    const handleIconClick = (icon: 'disponivel' | 'proximo') => {
        setActiveIcon((prev) => (prev === icon ? null : icon));
        if (activeIcon !== icon) {
            setTempPickerValue(pickerValue);
        }
    };

    const handleDistanceChange = (val: { distance: string }) => {
        setTempPickerValue(val);
    };

    const handleApply = () => {
        setPickerValue(tempPickerValue);
        setActiveIcon(null);
    };

    return (
        <>
            {activeIcon === 'proximo' && <div className={styles.backdrop} />}

            <div className={styles.wrapper}>
                {/*{activeIcon !== 'proximo' && <div className={styles.distanceBadge}>{pickerValue.distance}</div>} */}

                {activeIcon === 'proximo' && (
                    <div className={styles.pickerContainer}>
                        <RoundProfilePicture icon="fa-thin fa-car" labelText={translations.select} />
                        <NumberPicker
                            selections={{
                                distance: ['250 m', '500 m', '1 km', '1,5 km', '2 km', '2,5 km', '3 km'],
                            }}
                            value={tempPickerValue}
                            onChange={handleDistanceChange}
                        />
                        <Button
                            label={translations.apply}
                            mode={ButtonMode.primary}
                            classes={styles.button}
                            onClick={handleApply}
                        />
                    </div>
                )}

                <div className="z-3">{/*<BottomCarSearch activeIcon={activeIcon} onIconClick={handleIconClick} /> */}</div>
            </div>
        </>
    );
};
